import gql from "graphql-tag";
const invokeApiJSQuery = gql(` 
query invokeJS($event: AWSJSON!) {
  invokeJS(event: $event) {
    status
  }
}
`)
export default invokeApiJSQuery;
